import * as React from 'react';
import styles from './BidPlacingErrorPopup.scss';
import { useDispatch } from 'react-redux';
import useClickAway from '~/hooks/useClickAway';
import useKeyDown, { KEYS_CODE } from '~/hooks/useKeyDown';
import { ZoomInDiv } from '~/components/Transitions';
import { t } from '~/utils/localization';
import Button from '~/components/Button/Button';
import { playButtonClickSound } from '~/api/WoWsClient';
import { PopupManagerContext } from '~/Contexts/PopupManagerContext';
import { appActions } from '~/Store/appSlice';
import { POPUPS_NAME } from '~/components/PopupManager';

const BidPlacingErrorPopup = () => {
    const { isPopupActive } = React.useContext(PopupManagerContext);
    const dispatch = useDispatch();
    const ref = React.useRef(null);

    const close = () => dispatch(appActions.changeVisibilityPopup({ name: POPUPS_NAME.BID_ERROR_PLACED }));

    useClickAway(
        ref,
        () => {
            if (!isPopupActive) {
                return;
            }
            close();
        },
        [isPopupActive],
    );

    useKeyDown(() => {
        if (!isPopupActive) {
            return;
        }
        playButtonClickSound();
        close();
    }, [KEYS_CODE.ESC]);

    return (
        <ZoomInDiv className={styles.wrapper} ref={ref}>
            <div className={styles.content}>
                <div className={styles.icon} />
                <div className={styles.betTitle}>{t('Произошла ошибка. Попробуйте сделать ставку позднее')}</div>
                <div className={styles.footer}>
                    <Button label={t('Закрыть')} onClick={close} />
                </div>
            </div>
        </ZoomInDiv>
    );
};

export default BidPlacingErrorPopup;
